import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { User } from '../../../../types';
import { etchBrandThemeWithAboutCompany } from '../../index';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import { useEffect, useState } from 'react';

interface QuestionSectionProps {
    title: string;
    coordinator: User;
    brandTheme?: etchBrandThemeWithAboutCompany;
}

const displayName = (fullName: string | null, givenName: string, familyName: string) => {
    let name = fullName;
    if (!name) {
        name = `${givenName} ${familyName}`;
    }
    return name;
};

const firstLetter = (name: string) => {
    return name?.charAt(0).toUpperCase();
};

const QuestionSection: React.FC<QuestionSectionProps> = ({ title, coordinator, brandTheme }) => {
    const [imageHasError, setImageHasError] = useState<boolean>(false);

    useEffect(() => {
        const img = new Image();

        if (coordinator?.profileUrl) {
            img.onerror = () => {
                setImageHasError(true);
            };
            img.src = coordinator.profileUrl;
        }
        console.log('coordinator', coordinator);

        return () => {
            img.onerror = null;
        };
    }, [coordinator]);

    return (
        <>
            <h3 className="heading-2">{title}</h3>
            <div className="coordinatorArea">
                <div className="coordinatorItem">
                    <div className="coordinatorImageContainer">
                        {coordinator?.profileUrl && !imageHasError ? (
                            <img
                                src={coordinator.profileUrl}
                                className="coordinatorImage"
                                alt={displayName(coordinator.fullName, coordinator.givenName, coordinator.familyName)}
                            />
                        ) : (
                            <div
                                className="roundedImgPlaceholder flex"
                                style={{ backgroundColor: brandTheme?.meetCompanyColor }}
                            >
                                {firstLetter(
                                    displayName(coordinator.fullName, coordinator.givenName, coordinator.familyName),
                                )}
                            </div>
                        )}
                        <div className="coordinatorNameArea">
                            <div className="coordinatorName">
                                {displayName(coordinator.fullName, coordinator.givenName, coordinator.familyName)}
                            </div>
                            <div className="coordinatorTitle">{coordinator.title}</div>
                        </div>
                        <a
                            href={`mailto:${coordinator?.email}`}
                            className="btn coordinatorButton"
                            style={{ marginLeft: 'auto' }}
                        >
                            <FontAwesomeIcon icon={faEnvelope} />
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuestionSection;
